import React from "react";
import "./Sidebar.scss";
import { SidebarMenu } from "./SidebarMenu";
import { Ripple } from "primereact/ripple";
import { NavLink } from "react-router-dom";

export default function Sidebar() {
  return (
    <section className="sidebar">
      {SidebarMenu.map((item, i) => {
        return (
          <div className="main-menu" key={i}>
            <li>{item.label}</li>
            <ul className="sub-menu">
              {item.menus.map((subMenu, j) => {
                return (
                  <li key={i + "" + j}>
                    <NavLink
                      to={subMenu.url}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      {subMenu.icon}
                      {subMenu.menu}
                      <Ripple />
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </section>
  );
}
